import { useEffect, useState } from "react";
import { supabase } from "../lib/supabaseClient.ts";
import MySlider from "./MySlider.js";

function MainSlider() {

  const settings = {
    autoplay: false,
    autoplaySpeed: 10000,
    dots: false,
    fade: true,
    arrows: true,
    swipe: true,
    touchMove: true,
    // nextArrow: <CustomNextArrow />,
    // prevArrow: <CustomPrevArrow />,
    responsive: [
      { breakpoint: 767, settings: { dots: false, arrows: false } }
    ]
  };
const [slides, setSlides] = useState([]);

useEffect(() => {
  const fetchSlides = async () => {
    const { data, error } = await supabase
      .from('main_slider')
      .select('*')
      .order('order_index', { ascending: true });

    if (error) {
      console.error("Erreur Supabase :", error);
    } else {
      setSlides(data);
    }
  };

  fetchSlides();
}, []);


  return (
<section className="slider-area" style={{ overflowX: 'hidden', width: '100%', position: 'relative' }}>
  <div className="text-center d-md-none mt-2">
    {/* <small className="text-muted">Swipe ⟷</small> */}
  </div>
  <MySlider slides={slides} settings={settings} />

</section>

  );
}

export default MainSlider;
